import React, {useState} from 'react';

const LastUses = ({lastUsesArr = null, onclick = null, cycleStart = ''}) => {
  const [opened, setOpened] = useState('');
  const toggleOpening = () => {
    if (onclick != null) {
      onclick();
    }
    if (opened == '') setOpened('Open');
    else setOpened('');
  };

  let returned = '',
    details = '';
  if (lastUsesArr != null && lastUsesArr.length > 0) {
    details = lastUsesArr.map((d) => {
      return (
        <div className='LastUseDetail' key={lastUsesArr.indexOf(d)}>
          <span>{d.usageType}</span>
          <span>{d.lastHour}</span>
          <span>{d.lastDate}</span>
        </div>
      );
    });
    returned = (
      <div className='LastUsesContainer'>
        <div className='LastUsesHeader' onClick={toggleOpening}>
          מה היה השימוש האחרון? <span className={'OpenCloseLastUses ' + opened}>+</span>
        </div>
        <div className={'LastUses ' + opened}>
          {/* <p className='LastUsesDisclaimer'>במחזור חיוב זה: {cycleStart} - היום</p> */}
          {details}
        </div>
      </div>
    );
  } else {
    returned = (
      <div className='LastUsesContainer'>
        <div className='LastUsesHeader' onClick={toggleOpening}>
          מה היה השימוש האחרון? <span className={'OpenCloseLastUses ' + opened}>+</span>
        </div>
        <div className={'LastUses ' + opened}>
          {/* <p className='LastUsesDisclaimer'>במחזור חיוב זה: {cycleStart} - היום</p> */}
          <div className='LastUseDetail' style={{textAlign:"center"}}>
            <span>אין שימוש אחרון!</span>
          </div>
        </div>
      </div>
    );
  }

  return returned;
};

export default LastUses;
